<template>
    <router-link :to="photoAlbum.link" :title="photoAlbum.title" class="clean">
        <div class="uk-card uk-card-default uk-box-shadow-hover-large card-photoAlbum">

            <div class="uk-card-media-top">
                <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${photoAlbum.featuredImage.smallSquare})` }" :alt="photoAlbum.title" v-if="photoAlbum?.featuredImage.smallSquare"></div>
            </div>

            <div class="uk-card-body uk-text-left">
                <h4 class="uk-card-title"><b>{{photoAlbum.title}}</b></h4>
                <!-- <p class="summary">{{photoAlbum.summary}}</p> -->
            </div>

            <!-- <span class="uk-button uk-button-primary uk-width-1-1">View Album</span> -->
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['photoAlbum']
}
</script>
